// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OperacaoServiceOrders_CardsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /dashboards/operacao_service_orders/cards.
 *
 * Returns one CardsRow per `so_order_item_type` value found in the user's
 * filtered scope (franchise + date range). Counters cover delivered /
 * pending / overdue order items grouped by type.
 */
import type { OperacaoServiceOrders_CardsRow } from './OperacaoServiceOrders_CardsRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface OperacaoServiceOrders_CardsResponseDados {
cards: OperacaoServiceOrders_CardsRow[]
}

export type OperacaoServiceOrders_CardsResponse = ApiResponse<OperacaoServiceOrders_CardsResponseDados>;

registerResponseContract('OperacaoServiceOrders_CardsResponse', {
  cards: {
    type: 'array',
    required: true,
    items: {
      item_type: { type: 'string',  required: true },
      delivered: { type: 'number',  required: true },
      pending:   { type: 'number',  required: true },
      overdue:   { type: 'number',  required: true },
    },
  },
})
